import { render, staticRenderFns } from "./LehrkraefteIcon.vue?vue&type=template&id=6bb0f5ac"
import script from "./LehrkraefteIcon.vue?vue&type=script&lang=js"
export * from "./LehrkraefteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports